/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Import_Status_Creating_ProjectInputs */

const en_iconik_import_status_creating_project = /** @type {(inputs: Iconik_Import_Status_Creating_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating project...`)
};

const fr_iconik_import_status_creating_project = /** @type {(inputs: Iconik_Import_Status_Creating_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creation du projet...`)
};

const de_iconik_import_status_creating_project = /** @type {(inputs: Iconik_Import_Status_Creating_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt wird erstellt...`)
};

const it_iconik_import_status_creating_project = /** @type {(inputs: Iconik_Import_Status_Creating_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creazione del progetto...`)
};

const ru_iconik_import_status_creating_project = /** @type {(inputs: Iconik_Import_Status_Creating_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создание проекта...`)
};

const es_iconik_import_status_creating_project = /** @type {(inputs: Iconik_Import_Status_Creating_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creando proyecto...`)
};

const zh_cn2_iconik_import_status_creating_project = /** @type {(inputs: Iconik_Import_Status_Creating_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建项目...`)
};

const ja_iconik_import_status_creating_project = /** @type {(inputs: Iconik_Import_Status_Creating_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトを作成しています...`)
};

const hi_iconik_import_status_creating_project = /** @type {(inputs: Iconik_Import_Status_Creating_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट तैयार हो रहा है...`)
};

const pt_pt2_iconik_import_status_creating_project = /** @type {(inputs: Iconik_Import_Status_Creating_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criando projeto...`)
};

/**
* | output |
* | --- |
* | "Creating project..." |
*
* @param {Iconik_Import_Status_Creating_ProjectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_import_status_creating_project = /** @type {((inputs?: Iconik_Import_Status_Creating_ProjectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Import_Status_Creating_ProjectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_import_status_creating_project(inputs)
	if (locale === "de") return de_iconik_import_status_creating_project(inputs)
	if (locale === "it") return it_iconik_import_status_creating_project(inputs)
	if (locale === "ru") return ru_iconik_import_status_creating_project(inputs)
	if (locale === "es") return es_iconik_import_status_creating_project(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_import_status_creating_project(inputs)
	if (locale === "ja") return ja_iconik_import_status_creating_project(inputs)
	if (locale === "hi") return hi_iconik_import_status_creating_project(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_import_status_creating_project(inputs)
	return en_iconik_import_status_creating_project(inputs)
});